import * as actions from "./actionsTypes";

const initialData = {
  loaderFormalEducationMetrics: false,
  formalEducationMetrics: null,
  formalEducationMetricsAnio: null,
  formalEducationMetricsAll: null,
  formalEducationMetricsFail: null,
  saveLoaderFormalEducationMetrics: false,
  formalEducationMetricsFormError: null,
};

export default function FormalEducationMetricsReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_FORMAL_EDUCATION_METRICS:
      return {
        ...state,
        loaderFormalEducationMetrics: action.payload
      };

    case actions.GET_FORMAL_EDUCATION_METRICS:
      return {
        ...state,
        formalEducationMetrics: action.payload.formalEducationMetrics,
        formalEducationMetricsAnio: action.payload.formalEducationMetricsAnio,
        formalEducationMetricsAll: action.payload.formalEducationMetricsAll


      };

    case actions.FORMAL_EDUCATION_METRICS_FAIL:
      return { ...state, formalEducationMetricsFail: action.payload };

    case actions.SAVE_LOADER_FORMAL_EDUCATION_METRICS:
      return { ...state, saveLoaderFormalEducationMetrics: action.payload };

    case actions.FORM_FORMAL_EDUCATION_METRICS_FAIL:
      return { ...state, formalEducationMetricsFormError: action.payload };

    default:
      return state;
  }
}
